import React, { useState, useEffect } from "react";
import {  useForm } from "react-hook-form";
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CForm,
  CFormInput,
  CFormLabel
} from "@coreui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import toast from "react-hot-toast";
import {
  createUser,
  getSingleUser,
  updateUser,
} from "../../../services/user.services";
import {
  getAllActiveUserTypeList,
} from "src/services/user-type.services";
import {
  getStoreList,
} from "../../../services/store.services";
import { uploadImage } from "src/services/util.services";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { getActiveCountryList } from "src/services/country.services";
import { initialValues, schema } from "./static";

const CreateDriverForm = () => {
  const userInfo = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  const [userId, setUserId] = useState("");
  const [userData, setUserData] = useState(null);
  const [countryData, setCountryData] = useState([]);
  const [countrySelectOptions, setCountrySelectOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [allUserTypeData, setAllUserTypeData] = useState(null);
  const [userTypeData, setUserTypeData] = useState([]);
  const [userImage, setUserImage] = useState(null);
  const { id } = useParams();
  const [selecteduserType, setSelecteduserType] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedStoreOption, setSelectedStoreOption] = useState(null);
  const [storeOptions, setStoreOptions] = useState([]);

  //store userType value = 64a64b36a2ef02fb5725b215
  

  const {
    control,
    register,
    setValue,
    handleSubmit,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: initialValues(selectedCountry),
    resolver: zodResolver(schema(selecteduserType,userId)),
  });

  useEffect(() => {
    if (userInfo?.country) {
      setSelectedCountry({
        value: userInfo.country._id,
        label: `${userInfo.country.name}-${userInfo.country.code}`,
      });
      setValue("country", userInfo.country._id);
      getStoreInfo(userInfo.country._id);
    }
    if (userInfo?.userType === "superAdmin") {
      getCountryList();
    }
    getUserTypeInfo();
    // getStoreInfo();
  }, []);

  useEffect(() => {
    if (id) {
      setUserId(id);
      getUserInfo(id);
    }
    console.log("id======", id);
  }, [id]);

  const defaultPassword = "";

  const getCountryList = () => {
    let params = {
      limit: 20,
      page: 1,
      status: true,
    };
    getActiveCountryList(params)
      .then((response) => {
        if (response.success && response.data) {
          let countries = response.data;
          setCountryData(countries);
          let options = countries.map((item) => ({
            value: item._id,
            label: `${item.name}-${item.code}`,
          }));
          setCountrySelectOptions(options);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };

  const getUserInfo = (id) => {
    getSingleUser(id)
      .then(async (response) => {
        setUpdatedUserData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getUserTypeInfo = () => {
    getAllActiveUserTypeList()
      .then(async (response) => {
        const userType = response.data;
        setAllUserTypeData(userType);

        let options = userType.map((element) => ({
          label: element.name + " - " + element.type,
          value: element._id,
        }));
        setUserTypeData(options);
      })
      .catch((error) => {
        console.error(error?.response?.data);
      });
  };

  const getStoreInfo = (country, search = "") => {
    getStoreList({ limit: 100, page: 1, country, q: search })
      .then((response) => {
        if (response.success && response.data) {
          const storeData = response.data;
          let options = storeData.map((element) => ({
            value: `${element._id}`,
            label: `${element.name}`,
            locationCode: `${element.locationCode}`,
          }));
          setStoreOptions(options);
        }
      })
      .catch((error) => console.log(error?.response?.data));
  };

  const [defaultErrorMessage, setDefaultErrorMessage] = useState(
    '"Something went wrong. Please try again"'
  );

  const onSubmit = (data) => {
    if (selectedCountry) data.country = selectedCountry.value;
    data.userType="64a64aeba2ef02fb5725b214"

    if (userId) {
      if (data.password === defaultPassword) {
        data.password = "";
      }
      toast
        .promise(
          updateUser(data, userId),
          {
            loading: "Loading",
            success: "User Updated Succesfully",
            error: (err) => {
              return err.response &&
                err.response.data &&
                err.response.data.message
                ? err.response.data.message
                : defaultErrorMessage;
            },
          },
          {
            id: "updateuser",
          }
        )
        .then((response) => {
          console.log(response);
          setUpdatedUserData(response.data);
        })
        .catch((error) => console.error(error));
    } else {
      toast
        .promise(
          createUser(data),
          {
            loading: "Loading",
            success: "User Created Succesfully",
            error: (err) => {
              return err.response &&
                err.response.data &&
                err.response.data.message
                ? err.response.data.message
                : defaultErrorMessage;
            },
          },
          {
            id: "createuser",
          }
        )
        .then(async (response) => {
          reset();
          if (userInfo && userInfo?.country) {
            setSelectedCountry({
              value: userInfo.country._id,
              label: `${userInfo.country.name}-${userInfo.country.code}`,
            });
            setValue("country", userInfo.country._id);
          }
          setUserImage(null);
          setSelectedStoreOption("");
          setSelecteduserType("");
          setSelectedUser("");
        })
        .catch((error) => console.error(error));
    }
  };

  const onError = (err) => {
    console.error(err);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    toast
      .promise(
        uploadImage(formData, config),
        {
          loading: "Loading",
          success: "Image added Succesfully",
          error: (err) => {
            console.log(err);
            return "Something went wrong. Please upload again";
          },
        },
        {
          id: "login",
        }
      )
      .then(async (response) => {
        console.log("response", response);
        setValue("avatar", response.url);
        setUserImage(response.url);
      })
      .catch((error) => console.error(error));
  };

  const handleUserOnChange = (selectedOption) => {
    setValue("driverDetails", undefined);
    if (selectedOption) {
      console.log(selectedOption);
      // if (selectedOption.value === "64a64b36a2ef02fb5725b215")
      //   setIsStoreUser(true);
      setValue("userType", selectedOption.value);
      const filter = allUserTypeData.filter(
        (d) => d._id === selectedOption.value
      );
      setSelecteduserType(filter.length > 0 ? filter[0].type : "");
      setSelectedUser(selectedOption);
    } else {
      setValue("userType", "");
      setSelecteduserType("");
      setSelectedUser(null);
    }
  };

  const handleCountryChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedCountry(selectedOption);
      console.log(selectedOption);
      setValue("country", selectedOption.value);

      if (
        !["superAdmin", "admin", "cvit", "driver"].includes(
          selecteduserType.trim().toString()
        )
      ) {
        setSelectedStoreOption("");
        setValue("location", "");
        setValue("lastName", "");
        getStoreInfo(selectedOption?.value);
      }
    } else {
      setSelectedCountry("");
      setSelectedStoreOption("");
      setStoreOptions([]);
      setValue("country", "");
    }
  };

  const handleChangeStore = (selectedOption) => {
    if (selectedOption) {
      setSelectedStoreOption(selectedOption);
      setValue("location", selectedOption.value);
      if (selecteduserType === "store") {
        setValue("lastName", selectedOption?.locationCode);
        clearErrors("lastName");
      } else {
        setValue("lastName", "");
      }
      // if(selecteduserType)
    } else {
      setSelectedStoreOption("");
      setValue("location", "");
      if (userInfo.userType === "superAdmin") {
        getStoreInfo(selectedCountry?.value);
      } else {
        getStoreInfo(userInfo?.country?._id);
      }
    }
  };

  const handleStoreInputChange = (search) => {
    if (search) {
      let filtered = storeOptions.filter((item) => item.label.includes(search));
      if (filtered.length == 0) {
        getStoreInfo(userInfo?.country?._id, search);
      }
    }
  };

  const setUpdatedUserData = (data) => {
    setUserData(data);
    const {
      userType,
      designation,
      email,
      firstName,
      lastName,
      employeeCode,
      avatar,
      vehicleId,
      tagId,
      location,
      country,
      driverDetails,
    } = data;
    setValue("userType", userType._id);
    setValue("designation", designation ? designation : "");
    setValue("email", email);
    setValue("firstName", firstName);
    setValue("lastName", lastName);
    setValue("employeeCode", employeeCode);
    setValue("avatar", avatar ? avatar : "");
    setValue("password", defaultPassword);
    setValue("vehicleId", vehicleId ? vehicleId : "");
    setValue("tagId", tagId ? tagId : "");
    setValue("location", location ? location._id : "");
    setUserImage(avatar);

    if (country?._id && country?.code && country?.name) {
      setSelectedCountry({ value: country._id, label: country.name });
      setValue("country", country._id);
    }

    const fetchedUserType = { label: userType.name, value: userType._id };

    setSelectedUser(fetchedUserType);
    setSelecteduserType(userType.type);

    if (location) {
      const fetchedUserLocationType = {
        label: location?.name,
        value: location?._id,
        locationCode: location?.locationCode,
      };
      setSelectedStoreOption(fetchedUserLocationType);
    }
  };

  return (
    <CCard className="mb-4">
      <CCardBody>
        <CRow>
          <CCol sm={5}>
            <h4 id="traffic" className="card-title mb-0">
              {userId ? "Edit Driver" : "Create Driver"}
            </h4>
          </CCol>
          <CCol sm={7} className="d-none d-md-block"></CCol>
        </CRow>
        <hr />
        <br />
        <CForm onSubmit={handleSubmit(onSubmit, onError)}>
          <CRow>
            <CCol sm={6}>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="designation"
                  className="col-sm-3 col-form-label"
                >
                  Designation:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    id="designation"
                    {...register("designation")}
                  />
                  {errors.designation?.message && (
                    <p className="error_text">{errors.designation?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="employeeCode"
                  className="col-sm-3 col-form-label"
                >
                  Employee Code:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    maxLength={6}
                    id="employeeCode"
                    {...register("employeeCode")}
                  />
                  {errors.employeeCode?.message && (
                    <p className="error_text">{errors.employeeCode?.message}</p>
                  )}
                </CCol>
              </CRow>
              {/* {selecteduserType==='driver'? */}
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="designation"
                  className="col-sm-3 col-form-label"
                >
                  Email:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput type="email" id="email" {...register("email")} />
                  {errors.email?.message && (
                    <p className="error_text">{errors.email?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow
                className={`mb-3`}
              >
                <CFormLabel
                  htmlFor="password"
                  className="col-sm-3 col-form-label"
                >
                  Password:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="password"
                    id="password"
                    {...register("password")}
                  />
                  {errors.password?.password.message && (
                    <p className="error_text">
                      {errors.password?.password.message}
                    </p>
                  )}
                </CCol>
              </CRow>
              {/* :''} */}
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="avatar"
                  className="col-sm-3 col-form-label"
                >
                  Image:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="file"
                    accept="image/*"
                    onChange={handleFileUpload}
                  />

                  {errors.avatar?.message && (
                    <p className="error_text">{errors.avatar?.message}</p>
                  )}
                </CCol>
              </CRow>
            </CCol>
            <CCol sm={6}>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="country"
                  className="col-sm-3 col-form-label"
                >
                  Country:
                </CFormLabel>
                <CCol sm={8}>
                  <Select
                    value={selectedCountry}
                    options={countrySelectOptions}
                    onChange={handleCountryChange}
                    isClearable={true}
                    placeholder="Select Country"
                    isDisabled={
                      userInfo.userType === "superAdmin" ? false : true
                    }
                  />
                  {errors.country?.message && (
                    <p className="error_text">{errors.country?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow
                className={`mb-3 ${
                  !["driver", "admin", "cvit"].find(
                    (v) => selecteduserType === v
                  )
                    ? ""
                    : "d-none"
                }`}
              >
                {/* <CFormLabel
                  htmlFor="designation"
                  className="col-sm-3 col-form-label"
                >
                  Location:
                </CFormLabel>
                <CCol sm={8}>
                  <Select
                    value={selectedStoreOption}
                    onChange={handleChangeStore}
                    onInputChange={handleStoreInputChange}
                    options={storeOptions}
                    isClearable={true}
                    required={
                      !["driver", "admin", "cvit"].includes(selecteduserType)
                    }
                    isDisabled={selectedCountry ? false : true}
                  />
                  {errors.location?.message && (
                    <p className="error_text">{errors.location?.message}</p>
                  )}
                </CCol> */}
              </CRow>
              {/* {selecteduserType !== "store" && ( )} */}
                <CRow className="mb-3">
                  <CFormLabel
                    htmlFor="firstName"
                    className="col-sm-3 col-form-label"
                  >
                    First Name:
                  </CFormLabel>
                  <CCol sm={8}>
                    <CFormInput
                      type="text"
                      id="firstName"
                    //   required={selecteduserType !== "store" ? true : false}
                      {...register("firstName")}
                    />
                    {errors.firstName?.message && (
                      <p className="error_text">{errors.firstName?.message}</p>
                    )}
                  </CCol>
                </CRow>
             

              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="lastName"
                  className="col-sm-3 col-form-label"
                >
                  {"Last Name:"}
                </CFormLabel>

                <CCol sm={8}>
                  {/* {selecteduserType !== "store" ? () : ( */}
                    <>
                      <CFormInput
                        type="text"
                        id="lastName"
                        {...register("lastName")}
                      />
                      {errors.lastName?.message && (
                        <p className="error_text">{errors.lastName?.message}</p>
                      )}
                    </>
                  
                    <>
                      {/* <CFormInput
                        type="text"
                        value={
                          selectedStoreOption
                            ? selectedStoreOption.locationCode
                            : ""
                        }
                        readOnly={true}
                      />
                      {errors.lastName?.message && (
                        <p className="error_text">Location code is required</p>
                      )} */}
                    </>
                  {/* )} */}
                </CCol>
              </CRow>

              

              <CRow
                className={`mb-3`}
              >
                <CFormLabel
                  htmlFor="tagId"
                  className="col-sm-3 col-form-label"
                >
                  Tag ID:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    id="tagId"
                    {...register("tagId")}
                  />
                  {errors.tagId?.message && (
                    <p className="error_text">{errors.tagId?.message}</p>
                  )}
                </CCol>
              </CRow>
              {/* <CRow
                className={`mb-3`}
              >
                <CFormLabel
                  htmlFor="vehicleId"
                  className="col-sm-3 col-form-label"
                >
                  Tag ID:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    id="vehicleId"
                    {...register("vehicleId")}
                  />
                  {errors.vehicleId?.message && (
                    <p className="error_text">{errors.vehicleId?.message}</p>
                  )}
                </CCol>
              </CRow> */}

              {userImage ? (
                <CRow className="mb-3">
                  <CCol sm={12}>
                    <img src={userImage} height={110} />
                  </CCol>
                </CRow>
              ) : (
                ""
              )}
            </CCol>
            <div className="d-flex justify-content-end mt-3">
              <CButton type="submit" color="primary" className="px-5 py-2 me-3">
                Submit
              </CButton>
            </div>
          </CRow>
        </CForm>
      </CCardBody>
    </CCard>
  );
};

export default CreateDriverForm;
